export default "__VITE_ASSET__DSx3mD8P__"